<!-- @format -->

<div>
	<div class="head-section">
		<h6 class="header-text text-white">EDIT OTHER PERSONAL INFORMATION</h6>
		<svg
			width="19"
			height="19"
			viewBox="0 0 19 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			(click)="close()"
		>
			<g clip-path="url(#clip0_3558_32756)">
				<path
					d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345"
					stroke="#F00000"
					stroke-width="2.16781"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3558_32756">
					<rect
						width="17.3425"
						height="17.3425"
						fill="white"
						transform="translate(0.806641 0.748047)"
					/>
				</clipPath>
			</defs>
		</svg>
	</div>

	<div class="body-section">
		<form
			class="cust-width m-3"
			[formGroup]="form"
		>
			<div class="form-grid">
				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Income Category</label>
						<select
							class="form-control"
							formControlName="incomeCategory"
						>
							<option value="">Select option</option>
							<option
								*ngFor="let category of incomeCategories"
								[value]="category"
							>
								{{ category }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="isIncomeCategory('EMPLOYED')"
				>
					<div class="form-group mb-2">
						<label>Name Of Employer</label>
						<input
							type="text"
							class="form-control"
							formControlName="employerName"
							placeholder="Enter employer name"
						/>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="isIncomeCategory('EMPLOYED')"
				>
					<div class="form-group mb-2">
						<label>Income/Salary Range Per Annum</label>
						<input
							type="text"
							class="form-control"
							formControlName="incomeRange"
							placeholder="Enter annual salary range"
						/>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowSourceAndIncome()"
				>
					<div class="form-group mb-2">
						<label>Industry</label>
						<input
							type="text"
							class="form-control"
							formControlName="natureOfBusiness"
							placeholder="Enter industry"
						/>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowSourceAndIncome()"
				>
					<div class="form-group mb-2">
						<label>Source Of Income</label>
						<input
							type="text"
							class="form-control"
							formControlName="sourceOfIncome"
							placeholder="Enter source of income"
						/>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowSourceAndIncome()"
				>
					<div class="form-group mb-2">
						<label>Total Annual Income (₦)</label>
						<input
							type="text"
							class="form-control"
							formControlName="totalAnnualIncome"
							placeholder="Enter total annual income"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Highest Level of Education</label>
						<select
							class="form-control"
							formControlName="educationLevel"
						>
							<option value="">Select option</option>
							<option
								*ngFor="let level of educationLevels"
								[value]="level"
							>
								{{ level }}
							</option>
						</select>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>State of Origin</label>
						<select
							class="form-control"
							formControlName="stateOfOrigin"
						>
							<option value="">Select state</option>
							<option
								*ngFor="let state of states"
								[value]="state?.id"
							>
								{{ state?.name }}
							</option>
						</select>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>LGA of Origin</label>
						<select
							class="form-control"
							formControlName="lgaOfOrigin"
						>
							<option value="">Select LGA</option>
							<option
								*ngFor="let lga of lgaList"
								[value]="lga?.id"
							>
								{{ lga?.name }}
							</option>
						</select>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Nearest Landmark</label>
						<input
							type="text"
							class="form-control"
							formControlName="landMark"
							placeholder="Enter nearest landmark"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Accommodation Type</label>
						<select
							class="form-control"
							formControlName="accommodationType"
						>
							<option value="">Select option</option>
							<option
								*ngFor="let option of accommodationTypes"
								[value]="option"
							>
								{{ option | titlecase }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowBuildingType()"
				>
					<div class="form-group mb-2">
						<label>Building Type</label>
						<select
							class="form-control"
							formControlName="buildingType"
						>
							<option value="">Select option</option>
							<option
								*ngFor="let option of buildingTypes"
								[value]="option"
							>
								{{ option | titlecase }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowRentFields()"
				>
					<div class="form-group mb-2">
						<label>Period Type</label>
						<select
							class="form-control"
							formControlName="periodType"
						>
							<option value="">Select option</option>
							<option
								*ngFor="let option of periodTypes"
								[value]="option"
							>
								{{ option | titlecase }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowRentFields()"
				>
					<div class="form-group mb-2">
						<label>Rent Period Covered</label>
						<input
							type="text"
							class="form-control"
							formControlName="rentPeriodCovered"
							placeholder="e.g. Jan 2024 - Dec 2024"
						/>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowRentFields()"
				>
					<div class="form-group mb-2">
						<label>Rent Amount</label>
						<input
							type="text"
							class="form-control"
							formControlName="rentAmount"
							placeholder="Enter rent amount"
						/>
					</div>
				</div>

				<!-- <div
					class="form-grid-item"
					*ngIf="shouldShowRoomCount()"
				>
					<div class="form-group mb-2">
						<label>No. of Rooms</label>
						<input
							type="text"
							class="form-control"
							formControlName="numberOfRooms"
							placeholder="Enter number of rooms"
						/>
					</div>
				</div> -->

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Landlord Name</label>
						<input
							type="text"
							class="form-control"
							formControlName="landlordFullName"
							placeholder="Enter landlord name"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Landlord Phone Number</label>
						<input
							type="text"
							class="form-control"
							formControlName="landlordPhoneNumber"
							placeholder="Enter landlord phone number"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Landlord ASIN</label>
						<input
							type="text"
							class="form-control"
							formControlName="landlordAsin"
							placeholder="Enter landlord ASIN"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Landlord Email</label>
						<input
							type="email"
							class="form-control"
							formControlName="landlordEmail"
							placeholder="Enter landlord email"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Does Landlord Live In Same Apartment?</label>
						<select
							class="form-control"
							formControlName="doesLandlordLiveSameApartment"
						>
							<option
								*ngFor="let option of yesNoOptions"
								[value]="option"
							>
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowLandlordAddress()"
				>
					<div class="form-group mb-2">
						<label>Landlord Address</label>
						<input
							type="text"
							class="form-control"
							formControlName="landlordAddress"
							placeholder="Enter landlord address"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Do you have a vehicle?</label>
						<select
							class="form-control"
							formControlName="hasVehicle"
						>
							<option
								*ngFor="let option of yesNoOptions"
								[value]="option"
							>
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowVehicleCount()"
				>
					<div class="form-group mb-2">
						<label>How Many Vehicles Owned?</label>
						<input
							type="text"
							class="form-control"
							formControlName="numberOfVehicles"
							placeholder="Enter number of vehicles"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Do you have a property?</label>
						<select
							class="form-control"
							formControlName="hasProperty"
						>
							<option
								*ngFor="let option of yesNoOptions"
								[value]="option"
							>
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<div
					class="form-grid-item"
					*ngIf="shouldShowPropertyType()"
				>
					<div class="form-group mb-2">
						<label>Assets/Property Type</label>
						<input
							type="text"
							class="form-control"
							formControlName="propertyType"
							placeholder="Enter property type"
						/>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Do you own a Business</label>
						<select
							class="form-control"
							formControlName="hasBusiness"
						>
							<option
								*ngFor="let option of yesNoOptions"
								[value]="option"
							>
								{{ option }}
							</option>
						</select>
					</div>
				</div>

				<div class="form-grid-item">
					<div class="form-group mb-2">
						<label>Do you own a Business Venture</label>
						<select
							class="form-control"
							formControlName="ownCompany"
						>
							<option
								*ngFor="let option of yesNoOptions"
								[value]="option"
							>
								{{ option }}
							</option>
						</select>
					</div>
				</div>
			</div>
		</form>

		<div class="modal-footer">
			<div class="top-border other-width d-flex justify-content-end">
				<button
					type="button"
					class="btn btn-sm btn-outline-dark custom-button-style"
					[disabled]="isLoading"
					(click)="confirmSave()"
				>
					<span *ngIf="!isLoading">Update Information</span>
					<span
						*ngIf="isLoading"
						class="spinner-border spinner-border-sm text-light"
					></span>
				</button>
			</div>
		</div>
	</div>
</div>
